module.exports = __webpack_public_path__ + "static/media/dmi-finance.f53b00c2.svg";